'use client';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components';
import { DiscoveryProfile } from '@/redux/slices/discoverySlice';
import ProfileSearchCard from './ProfileSearchCard';
import './EmptyState.scss';

interface EmptyStateProps {
  hasLocation: boolean;
  isLoadingSpotlight: boolean;
  spotlightProfiles: DiscoveryProfile[];
}

const EmptyState: React.FC<EmptyStateProps> = ({
  hasLocation,
  isLoadingSpotlight,
  spotlightProfiles,
}) => {
  const navigate = useNavigate();

  if (!hasLocation) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📍</div>
        <h2>Location Required</h2>
        <p>Please set your home or touring location in settings to discover profiles near you.</p>
        <button
          className="settings-btn"
          onClick={() => navigate('/settings')}
        >
          Go to Settings
        </button>
      </div>
    );
  }

  return (
    <div className="empty-state">
      <div className="empty-state-icon">🔍</div>
      <h2>No Profiles Found</h2>
      <p>Try adjusting your filters or expanding your search radius.</p>

      {/* Spotlight Profiles Section */}
      {isLoadingSpotlight && (
        <LoadingSpinner size="small" message="Loading trending profiles..." />
      )}

      {!isLoadingSpotlight && spotlightProfiles.length > 0 && (
        <div className="spotlight-section">
          <h3>Trending Profiles</h3>
          <p className="spotlight-subtitle">Check out these popular profiles while you're here</p>
          <div className="spotlight-grid">
            {spotlightProfiles.map((profile) => (
              <ProfileSearchCard key={profile.id} profile={profile} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
